module.exports = __webpack_public_path__ + "static/logo-48dc1d320fcf6a5fb875ebe62a035658.png";